<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <!-- BOTON DE NUEVO  -->

      <div class="card-header">
        <div class="row">
          <div class="col-sm-6 text-sm-right">
            <button *hasPermission="{app: constant.EQUIPO_GERENCIAL, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect"
              (click)="openModal()">
              <i class="fas fa-plus fa-lg mr-1"></i> Nuevo
            </button>
          </div>
        </div>
      </div>
      <!-- BOTON DE NUEVO FIN -->

      <!-- TABLA  EQUIPO GENERNCIAL-->

      <div id="accordion1" class=" pt-1" >
        <div class="card mb-1 py-0">
          <div class="card-header py-0 px-0 my-0" id="heading1">
            <h5 class="accordion-header py-0" id="heading1">
              <a class="accordion-button py-2 text-reset"
                data-bs-toggle="collapse" href="#equipoGerencial"
                aria-expanded="true" aria-expanded="true"
                aria-controls="collapseOne">
                {{"Equipo Gerencial"}}
              </a>
            </h5>
          </div>
          <div id="equipoGerencial" class="collapse py-0" aria-labelledby='heading1'data-bs-parent="#accordion5">
            <div class="card-body  py-0">
                <div class="container card-body table-responsive  py-0">
                  <table datatable [dtOptions]="dtOptions"
                    [dtTrigger]="dtTrigger"
                    class="table table-striped table-bordered row-border hover">
                    <thead>
                      <tr>
                        <th>Nro.</th>
                        <th>Grado / Nombre</th>
                        <th>Cédula</th>
                        <th>Tipo participante</th>
                        <th>Fecha inicio</th>
                        <th>Fecha fin</th>
                        <th>Estado</th>
                        <th>Acción</th>
                      </tr>
                    </thead>

                    <tbody

                      *ngFor="let subSistem of indiceEquipoGerencial;let items=index" >
                      <tr>
                        <td>{{items+1}}</td>
                        <td>{{ subSistem.gradoNombres }}</td>
                        <td>{{ subSistem.cedula }}</td>
                        <td>{{getNombreTipoParticipacion(subSistem.idSprTipoParticipante,
                          listaCat)[0]?.nombre}}/{{subSistem.cargoFuncion}}</td>
                        <td>{{ subSistem.fechaInicio | date: 'dd-MM-yyyy'}}</td>
                        <td>{{ subSistem.fechaFin | date: 'dd-MM-yyyy'}}</td>
                        <td>{{ subSistem.estado == "1" ? "Activo" : "Inactivo"
                          }}</td>
                        <td class="text-center">
                          <div class="row">
                            <button *hasPermission="{app: constant.EQUIPO_GERENCIAL, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Seleccionar este registro" (click)="updateEquipoGerencial(subSistem)">
                              <i class="fas fa-pencil-alt fa-lg"></i>
                            </button>
                            <button *hasPermission="{app: constant.EQUIPO_GERENCIAL, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro" (click)="deleteEquipoGerencial(subSistem.idSprEquipoGerencial)">
                              <i class="fas fa-trash-alt fa-lg"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
        </div>
      </div>

    <!-- TABLA FIN -->

    <!-- TABLA  EQUIPO DEL PROYECTO-->

    <div id="accordion2" class="mb-0">
      <div class="card mb-1 py-0">
        <div class="card-header py-0 px-0 my-0" id="heading2">
          <h5 class="accordion-header py-0" id="heading2">
            <a class="accordion-button py-2 text-reset"
              data-bs-toggle="collapse" href="#equipoProyecto"
              aria-expanded="true" aria-expanded="true"
              aria-controls="collapseTwo">
              {{"Equipo de Proyecto"}}
            </a>
          </h5>
        </div>
        <div id="equipoProyecto" class="collapse" aria-labelledby='heading2'data-bs-parent="#accordion1">
          <div class="card-body">
              <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions"
                  [dtTrigger]="dtTrigger"
                  class="table table-striped table-bordered row-border hover">
                  <thead>
                    <tr>
                      <th>Nro.</th>
                      <th>Grado / Nombre</th>
                      <th>Cédula</th>
                      <th>Tipo participante</th>
                      <th>Fecha inicio</th>
                      <th>Fecha fin</th>
                      <th>Estado</th>

                      <th>Acción</th>
                    </tr>
                  </thead>

                  <tbody
                    *ngFor="let subSistem of indiceEquipoProyecto; let indice=index">
                    <tr>
                    <td>{{indice+1}} </td>
                    <td>{{ subSistem.gradoNombres }}</td>
                    <td>{{ subSistem.cedula }}</td>
                    <td>{{ getNombreTipoParticipacion(subSistem.idSprTipoParticipante,
                      listaCat)[0]?.nombre}}/{{subSistem.cargoFuncion}}</td>
                    <td>{{ subSistem.fechaInicio | date: 'dd-MM-yyyy'}}</td>
                    <td>{{ subSistem.fechaFin | date: 'dd-MM-yyyy'}}</td>
                    <td>{{ subSistem.estado == "1" ? "Activo" : "Inactivo" }}</td>

                    <td class="text-center">
                      <div class="row">
                        <button type="button" tooltip="Editar"
                          class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                          title="Seleccionar este registro"
                          (click)="updateEquipoGerencial(subSistem)">
                          <i class="fas fa-pencil-alt fa-lg"></i>
                        </button>
                        <button type="button"
                          class="btn btn-sm btn-link waves-effect col px-0"
                          title="Eliminar este registro"
                          (click)="deleteEquipoGerencial(subSistem.idSprEquipoGerencial)">
                          <i class="fas fa-trash-alt fa-lg"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
    </div>
    <!-- TABLA FIN -->

    <!-- TABLA  RESPONSABLES-->
    <div id="accordion3" class="mb-0 ">
      <div class="card mb-1 py-0">
        <div class="card-header py-0 px-0 my-0" id="heading3">
          <h5 class="accordion-header py-0" id="heading3">
            <a class="accordion-button py-2 text-reset"
              data-bs-toggle="collapse" href="#responsable"
              aria-expanded="true" aria-expanded="true"
              aria-controls="collapseThree">
              {{"Responsable"}}
            </a>
          </h5>
        </div>
        <div id="responsable" class="collapse" aria-labelledby='heading3'data-bs-parent="#accordion2">
          <div class="card-body">
              <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions"
                  [dtTrigger]="dtTrigger"
                  class="table table-striped table-bordered row-border hover">
                  <thead>
                    <tr>
                      <th>Nro.</th>
                      <th>Grado / Nombre</th>
                      <th>Cédula</th>
                      <th>Tipo participante</th>
                      <th>Fecha inicio</th>
                      <th>Fecha fin</th>
                      <th>Estado</th>

                      <th>Acción</th>
                    </tr>
                  </thead>

                  <tbody
                    *ngFor="let subSistem of indiceResponsable; let indice=index">
                    <tr>
                    <td>{{indice+1}} </td>
                    <td>{{ subSistem.gradoNombres }}</td>
                    <td>{{ subSistem.cedula }}</td>
                    <td>{{ getNombreTipoParticipacion(subSistem.idSprTipoParticipante,
                      listaCat)[0]?.nombre}}/{{subSistem.cargoFuncion}}</td>
                    <td>{{ subSistem.fechaInicio | date: 'dd-MM-yyyy'}}</td>
                    <td>{{ subSistem.fechaFin | date: 'dd-MM-yyyy' }}</td>
                    <td>{{ subSistem.estado == "1" ? "Activo" : "Inactivo" }}</td>

                    <td class="text-center">
                      <div class="row">
                        <button type="button" tooltip="Editar"
                          class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                          title="Seleccionar este registro"
                          (click)="updateEquipoGerencial(subSistem)">
                          <i class="fas fa-pencil-alt fa-lg"></i>
                        </button>
                        <button type="button"
                          class="btn btn-sm btn-link waves-effect col px-0"
                          title="Eliminar este registro"
                          (click)="deleteEquipoGerencial(subSistem.idSprEquipoGerencial)">
                          <i class="fas fa-trash-alt fa-lg"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
    </div>
    <!-- TABLA FIN -->

    <!-- TABLA  EQUIPO LINEAS DE ACCION-->
    <div id="accordion4" class="mb-0">
      <div class="card mb-1 py-0">
        <div class="card-header py-0 px-0 my-0" id="heading4">
          <h5 class="accordion-header py-0" id="heading4">
            <a class="accordion-button py-2 text-reset"
              data-bs-toggle="collapse" href="#linea"
              aria-expanded="true" aria-expanded="true"
              aria-controls="collapseFour">
              {{"Equipo Línea de Acción"}}
            </a>
          </h5>
        </div>
        <div id="linea" class="collapse" aria-labelledby='heading4'data-bs-parent="#accordion3">
          <div class="card-body">
              <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions"
                  [dtTrigger]="dtTrigger"
                  class="table table-striped table-bordered row-border hover">
                  <thead>
                    <tr>
                      <th>Nro.</th>
                      <th>Grado / Nombre</th>
                      <th>Cédula</th>
                      <th>Tipo participante</th>
                      <th>Fecha inicio</th>
                      <th>Fecha fin</th>
                      <th>Estado</th>

                      <th>Acción</th>
                    </tr>
                  </thead>

                  <tbody
                    *ngFor="let subSistem of indiceEquipoLineaAccion; let indice=index">
                    <tr>
        <td>{{indice+1}} </td>
        <td>{{ subSistem.gradoNombres }}</td>
        <td>{{ subSistem.cedula }}</td>
        <td>{{ getNombreTipoParticipacion(subSistem.idSprTipoParticipante,
          listaCat)[0]?.nombre}}/{{subSistem.cargoFuncion}}</td>
        <td>{{ subSistem.fechaInicio | date: 'dd-MM-yyyy'}}</td>
        <td>{{ subSistem.fechaFin | date: 'dd-MM-yyyy'}}</td>
        <td>{{ subSistem.estado == "1" ? "Activo" : "Inactivo" }}</td>

        <td class="text-center">
          <div class="row">
            <button type="button" tooltip="Editar"
              class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
              title="Seleccionar este registro"
              (click)="updateEquipoGerencial(subSistem)">
              <i class="fas fa-pencil-alt fa-lg"></i>
            </button>
            <button type="button"
              class="btn btn-sm btn-link waves-effect col px-0"
              title="Eliminar este registro"
              (click)="deleteEquipoGerencial(subSistem.idSprEquipoGerencial)">
              <i class="fas fa-trash-alt fa-lg"></i>
            </button>
          </div>
        </td>
      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
    </div>
    <!-- TABLA FIN -->

    <!-- TABLA  EQUIPO PLANES DE ACCION-->
    <div id="accordion5" class="mb-0">
      <div class="card mb-1 py-0">
        <div class="card-header py-0 px-0 my-0" id="heading5">
          <h5 class="accordion-header py-0" id="heading5">
            <a class="accordion-button py-2 text-reset"
              data-bs-toggle="collapse" href="#plan"
              aria-expanded="true" aria-expanded="true"
              aria-controls="collapseFive">
              {{"Equipo Planes de Acción"}}
            </a>
          </h5>
        </div>
        <div id="plan" class="collapse" aria-labelledby='heading5'data-bs-parent="#accordion4">
          <div class="card-body">
              <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions"
                  [dtTrigger]="dtTrigger"
                  class="table table-striped table-bordered row-border hover">
                  <thead>
                    <tr>
                      <th>Nro.</th>
                      <th>Grado / Nombre</th>
                      <th>Cédula</th>
                      <th>Tipo participante</th>
                      <th>Fecha inicio</th>
                      <th>Fecha fin</th>
                      <th>Estado</th>

                      <th>Acción</th>
                    </tr>
                  </thead>

                  <tbody
                    *ngFor="let subSistem of indiceEquipoPlanAccion; let indice=index">
                    <tr>
                    <td>{{indice+1}} </td>
                    <td>{{ subSistem.gradoNombres }}</td>
                    <td>{{ subSistem.cedula }}</td>
                    <td>{{ getNombreTipoParticipacion(subSistem.idSprTipoParticipante,
                      listaCat)[0]?.nombre}}/{{subSistem.cargoFuncion}}</td>
                    <td>{{ subSistem.fechaInicio | date: 'dd-MM-yyyy'}}</td>
                    <td>{{ subSistem.fechaFin | date: 'dd-MM-yyyy'}}</td>
                    <td>{{ subSistem.estado == "1" ? "Activo" : "Inactivo" }}</td>

                    <td class="text-center">
                      <div class="row">
                        <button type="button" tooltip="Editar"
                          class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                          title="Seleccionar este registro"
                          (click)="updateEquipoGerencial(subSistem)">
                          <i class="fas fa-pencil-alt fa-lg"></i>
                        </button>
                        <button type="button"
                          class="btn btn-sm btn-link waves-effect col px-0"
                          title="Eliminar este registro"
                          (click)="deleteEquipoGerencial(subSistem.idSprEquipoGerencial)">
                          <i class="fas fa-trash-alt fa-lg"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
    </div>
    <!-- TABLA FIN -->

    <!-- MENSAJE DE ELIMINAR -->
    <jw-modal id="deleteEquipoGeren">
      <div class="modal-dialog" style="padding-top: 15%">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
            <button type="button" class="btn-close" (click)="modal.close()"></button>
          </div>
          <div class="modal-body">
            <p class="pl-4">
              <i class="pl-2 fas fa-exclamation-circle text-warning fa-lg fa-2x"></i>&nbsp;
              &nbsp; Esta seguro que
              desea eliminar este registro?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary waves-effect"
              (click)="modal.close()">
              Cancelar
            </button>
            <button type="button" class="btn btn-primary"
              (click)="confirmDelete()">
              Si, borrar!
            </button>
          </div>
        </div>
      </div>
    </jw-modal>
    <!-- FIN MENSAJE DE ELIMINAR -->

    <jw-modal id="{{ nameModal }}">
      <div class="modal-dialog" style="padding-top:6%">
        <div class="modal-content">
          <div class="modal-header pb-4">
            <h3 class="modal-title">{{nameEquipoGerencial}}</h3>
            <button type="button" class="btn-close" (click)="modal.close()"
              aria-label="Close"></button>
          </div>

          <div class="card-body pT-2">
            <form action="#" class="needs-validation" id="formCatSubsistema"
              [formGroup]="formUser"
              autocomplete="off">

              <div class="form-group row mb-2">
                <div class="col col-md-3 text-md-right">
                  <label for="nombre" class=" form-control-label text-md-right"><b>Cédula:</b></label>
                </div>

                <div class="col col-md-6 text-md-right pr-0">
                  <input type="hidden" id="idSprUsuario"
                    formControlName="idSprUsuario" requiered class="is-invalid">
                  <input type="text" maxlength="10"
                    onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false"
                    class="form-control pr-0" required="true"
                    formControlName="cedula"
                    [ngClass]="{'is-invalid':this.formUser.get('cedula')?.errors && this.formSubmitted,'is-valid': this.formUser.value.cedula}">
                </div>
                <div class="col col-md-2 pl-0 ">
                  <button type="submit" class="btn btn-info btn-block"
                    (click)="buscaPersona()">&nbsp;Buscar&nbsp;&nbsp;</button>
                </div>

              </div>
              <small class="invalid-feedback"
                *ngIf="this.formUser.get('cedula')?.errors?.['required'] && this.formSubmitted">Campo
                requerido</small>

              <div class="form-group row mb-2">
                <div class="col col-md-3 text-md-right">
                  <label for="gradoNombres"
                    class="form-control-label text-md-right pt-1"><b>Nombres:</b>
                  </label>
                </div>
                <div class="col-12 col-md-9">
                  <input type="text" class="form-control col-9" disabled
                    required="true"
                    value="{{ grado }} {{ apellidos }} {{ nombres }}"
                    [ngClass]="{'is-invalid': this.formEquipoGerencial.get('gradoNombres')?.errors && this.formSubmitted,'is-valid': this.formEquipoGerencial.get('gradoNombres')?.errors,}" />
                </div>
              </div>
            </form>

            <div class="needs-validation">
              <form [formGroup]="formEquipoGerencial" autocomplete="off"
                (ngSubmit)="createEquipoGerencial()">

                <div class="form-group row mb-2">
                  <div class="col col-md-3 text-md-right">
                    <label for="informacion"
                      class="form-control-label text-md-right pt-1"><b>Tipo
                        participante:</b>
                    </label>
                  </div>
                  <div class="col-12 col-md-9 ">
                    <select class="form-select col-5" id="idSprTipoParticipante"
                      formControlName="idSprTipoParticipante"
                      [ngClass]="{'is-invalid':this.formEquipoGerencial.get('idSprTipoParticipante')?.errors && this.formSubmitted,'is-valid': this.formEquipoGerencial.value.idSprTipoParticipante}">
                      <option *ngFor="let row of listaCat"
                        [value]="row.idSprComun">
                        <p *ngIf="row.idSprComun != idParticipantes">
                          {{ row.nombre }}
                        </p>
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group row mb-2">
                  <div class="col col-md-3 text-md-right">
                    <label for="cargoFuncion"
                      class="form-control-label text-md-right pt-1"><b>Función:</b>
                    </label>
                  </div>
                  <div class="col-12 col-md-9">
                    <input type="text" class="form-control col-9"
                      required="true" formControlName="cargoFuncion"
                      placeholder="Cargo Funcion" maxlength="255"
                      [ngClass]="{'is-invalid': this.formEquipoGerencial.get('cargoFuncion')?.errors && this.formSubmitted,'is-valid': !this.formEquipoGerencial.get('cargoFuncion')?.errors,}">
                  </div>
                </div>

                <div class="form-group row mb-2">
                  <div class="col col-md-3 text-md-right">
                    <label for="estado"
                      class="form-control-label text-md-right pt-1"><b>Estado:</b>
                    </label>
                  </div>
                  <div class="col-12 col-md-9 ">
                    <select class="form-select " id="estado"
                      formControlName="estado" required="true"
                      [ngClass]="{'is-invalid': this.formEquipoGerencial.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formEquipoGerencial.get('estado')?.errors,}">
                      <option value="1" selected>Activo</option>
                      <option value="2">Inactivo</option>
                    </select>
                    <div class="col text-danger">
                      <span class="font-italic"
                        *ngIf="this.formEquipoGerencial.get('estado')?.errors?.['required'] && this.formSubmitted">Campo
                        requerido</span>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary waves-effect"
                    data-dismiss="modal"
                    (click)="closeModal()">
                    Cancelar
                  </button>
                  <button type="submit" class="btn btn-info">
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </jw-modal>
  </div>
</div>